export default function getAuthToken(state) {
  if (state.loginForm && state.loginForm.authToken) {
    return state.loginForm.authToken;
  }
}